import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Loading from 'components/Loading';
import { requestAppointment, createPhaseAppointment, editPhaseAppointment, phaseAppointmentClearValidation } from 'actionCreators/appointments';
import SchedulePhaseAppointment from 'schedulePhaseAppointment';

class EditPhaseAppointment extends React.Component {
  componentWillMount = () => this.props.requestAppointment(this.props.params.appointmentId);

  componentWillUnmount = () => this.props.phaseAppointmentClearValidation();

  processSubmit = (phaseId, params, ssData, event, overrideReschedule = false) => {
    if (overrideReschedule) {
      return this.props.createPhaseAppointment(phaseId, params, ssData, event);
    }
    return this.props.editPhaseAppointment(
      this.props.params.appointmentId,
      this.props.params.id,
      params,
      ssData,
      event,
    );
  }

  render = () => {
    const { data, loading, errors } = this.props.appointmentState;
    if (loading) return (<Loading />);
    const { assignee } = data;
    const arrivalStart = moment(data.arrival_start_time, 'HH:mm');
    const arrivalEnd = moment(data.arrival_end_time, 'HH:mm');
    const startDate = moment(data.start_date).format('MM/DD/YYYY');
    const endDate = moment(data.end_date).format('MM/DD/YYYY');
    const pickupDate = data.pickup_date ? moment(data.pickup_date).format('MM/DD/YYYY') : null;
    const type = data.kind || '';
    let confirmationDate = null;
    if (data.appointment_confirmation_date) {
      confirmationDate = moment(data.appointment_confirmation_date).format('MM/DD/YYYY');
    }
    const apptObj = {
      id: data.id,
      schedulingReason: data.scheduling_reason,
      arrivalStart: arrivalStart.format('HH:mm'),
      arrivalEnd: arrivalEnd.format('HH:mm'),
      confirmationDate,
      startDate,
      endDate,
      pickupDate,
      selectedAssignee: assignee ? assignee[Object.keys(assignee)[0]] : null,
      apptType: type,
      note: data.note || '',
    };
    return (<SchedulePhaseAppointment
      onSubmit={this.processSubmit}
      appointment={apptObj}
      originalDate={apptObj.startDate}
      originalStart={apptObj.arrivalStart}
      originalEnd={apptObj.arrivalEnd}
      errors={errors}
      isEdit
    />);
  }
}

EditPhaseAppointment.propTypes = {
  createPhaseAppointment: PropTypes.func.isRequired,
  editPhaseAppointment: PropTypes.func.isRequired,
  requestAppointment: PropTypes.func.isRequired,
  phaseAppointmentClearValidation: PropTypes.func.isRequired,
  appointmentState: PropTypes.shape({
    data: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    errors: PropTypes.object,
  }),
  params: PropTypes.shape({
    id: PropTypes.string,
    appointmentId: PropTypes.string,
  }),
};

export default connect(
  state => ({ appointmentState: state.appointment }), {
    createPhaseAppointment,
    editPhaseAppointment,
    requestAppointment,
    phaseAppointmentClearValidation,
  },
)(EditPhaseAppointment);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/editPhaseAppointment.jsx